(function () {
  function ensureLayer(container, className) {
    if (!container || container.querySelector(':scope > svg.' + className)) return null;
    const style = getComputedStyle(container);
    if (style.position === 'static') container.style.position = 'relative';

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', className + ' espresso-doodle-layer');
    svg.setAttribute('aria-hidden', 'true');
    container.appendChild(svg);
    return svg;
  }

  function drawBean(rc, svg, x, y, size, stroke) {
    const bean = rc.ellipse(x, y, size, size * 1.35, {
      stroke,
      strokeWidth: 2.1,
      roughness: 1.4,
      bowing: 1.2,
      fill: 'transparent'
    });
    const crack = rc.line(x - size * 0.12, y - size * 0.3, x + size * 0.09, y + size * 0.24, {
      stroke,
      strokeWidth: 1.8,
      roughness: 1.3,
      bowing: 1.5
    });
    svg.appendChild(bean);
    svg.appendChild(crack);
  }

  function drawPlant(rc, svg, x, y, size, stroke) {
    const stem = rc.line(x, y + size * 0.36, x, y - size * 0.28, {
      stroke,
      strokeWidth: 2,
      roughness: 1.2,
      bowing: 1.1
    });
    const leafA = rc.ellipse(x - size * 0.2, y - size * 0.05, size * 0.42, size * 0.26, {
      stroke,
      strokeWidth: 1.9,
      roughness: 1.3,
      fill: 'transparent'
    });
    const leafB = rc.ellipse(x + size * 0.2, y + size * 0.08, size * 0.4, size * 0.24, {
      stroke,
      strokeWidth: 1.9,
      roughness: 1.3,
      fill: 'transparent'
    });
    svg.appendChild(stem);
    svg.appendChild(leafA);
    svg.appendChild(leafB);
  }

  function drawCup(rc, svg, x, y, size, stroke) {
    const w = size * 0.9;
    const h = size * 0.55;
    const cup = rc.rectangle(x - w / 2, y - h / 2, w, h, {
      stroke,
      strokeWidth: 2,
      roughness: 1.3,
      fill: 'transparent'
    });
    const saucer = rc.line(x - w * 0.65, y + h * 0.66, x + w * 0.65, y + h * 0.66, {
      stroke,
      strokeWidth: 1.8,
      roughness: 1.3,
      bowing: 1.2
    });
    svg.appendChild(cup);
    svg.appendChild(saucer);
  }

  function wrapHeroWord() {
    const heroHeading = document.querySelector(
      '.custom-home-hero__heading, .espresso-story-banner__heading, .hero .text-block.h2 > *, .hero .text-block.h1 > *'
    );
    if (!heroHeading || heroHeading.dataset.heroWordWrapped === 'true') return;

    const html = heroHeading.innerHTML;
    let updated = html.replace(/\b(caf[eé])\b/i, '<span class="hero-doodle-word">$1</span>');
    if (updated === html) {
      updated = html.replace(/\b(fruta)\b/i, '<span class="hero-doodle-word">$1</span>');
    }
    if (updated === html) {
      updated = html.replace(/^(\S+)/, '<span class="hero-doodle-word">$1</span>');
    }

    if (updated !== html) {
      heroHeading.innerHTML = updated;
      heroHeading.dataset.heroWordWrapped = 'true';
    }
  }

  function applyHeroNotation() {
    if (!window.RoughNotation || !window.RoughNotation.annotate) {
      drawHeroRoughUnderline();
      return;
    }

    const word = document.querySelector('.hero-doodle-word');
    if (!word || word.dataset.roughNotationReady === 'true') return;

    word.querySelectorAll('svg.rough-annotation').forEach((el) => el.remove());

    const annotation = window.RoughNotation.annotate(word, {
      type: 'underline',
      color: '#000000',
      strokeWidth: 4.4,
      animationDuration: 1000,
      padding: 4,
      iterations: 2
    });

    word.dataset.roughNotationReady = 'true';
    annotation.show();
  }

  function drawHeroRoughUnderline() {
    if (!window.rough || !window.rough.svg) return;
    const word = document.querySelector('.hero-doodle-word');
    if (!word || word.dataset.roughFallbackReady === 'true') return;

    if (getComputedStyle(word).position === 'static') {
      word.style.position = 'relative';
    }
    word.style.display = 'inline-block';

    const existing = word.querySelector(':scope > svg.hero-doodle-fallback');
    if (existing) existing.remove();

    const rect = word.getBoundingClientRect();
    const width = Math.max(46, rect.width + 18);
    const height = 22;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'hero-doodle-fallback');
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    svg.setAttribute('aria-hidden', 'true');
    svg.style.position = 'absolute';
    svg.style.left = '-8px';
    svg.style.bottom = '-9px';
    svg.style.width = `${width}px`;
    svg.style.height = `${height}px`;
    svg.style.pointerEvents = 'none';
    svg.style.overflow = 'visible';

    const rc = window.rough.svg(svg);
    const line = rc.path(`M 4 ${height - 7} C ${width * 0.26} ${height - 2}, ${width * 0.72} ${height - 12}, ${width - 4} ${height - 6}`, {
      stroke: 'rgba(0, 0, 0, 0.96)',
      strokeWidth: 4.4,
      roughness: 1.5,
      bowing: 1.4,
      fill: 'transparent'
    });

    svg.appendChild(line);
    word.appendChild(svg);
    word.dataset.roughFallbackReady = 'true';
  }

  function drawHomeBackgroundDoodles() {
    if (!window.rough || !window.rough.svg) return;
    const main = document.querySelector('#MainContent');
    if (!main) return;

    const sections = Array.from(document.querySelectorAll('main .shopify-section .section'))
      .filter((el) => el.offsetWidth > 260 && el.offsetHeight > 120 && !el.closest('.espresso-attitude-card'));

    sections.slice(0, 10).forEach((container) => {
      const svg = ensureLayer(container, 'espresso-doodle-home');
      if (!svg) return;
      const rc = window.rough.svg(svg);
      const rect = container.getBoundingClientRect();
      const w = Math.max(rect.width, 300);
      const h = Math.max(rect.height, 160);
      svg.setAttribute('viewBox', `0 0 ${w} ${h}`);

      const count = 3 + Math.floor(Math.random() * 4);
      for (let i = 0; i < count; i += 1) {
        const x = 28 + Math.random() * (w - 56);
        const y = 28 + Math.random() * (h - 56);
        const size = 40 + Math.random() * 34;
        const pick = Math.random();
        if (pick < 0.34) {
          drawBean(rc, svg, x, y, size, 'rgba(0, 0, 0, 0.78)');
        } else if (pick < 0.67) {
          drawPlant(rc, svg, x, y, size, 'rgba(0, 0, 0, 0.74)');
        } else {
          drawCup(rc, svg, x, y, size, 'rgba(0, 0, 0, 0.76)');
        }
      }
    });
  }

  function drawAttitudeCardIcons() {
    if (!window.rough || !window.rough.svg) return;

    const valueSections = document.querySelectorAll('[id*="section_values_native_F6x9Qp"]');

    valueSections.forEach((section) => {
      const wrappers = Array.from(section.querySelectorAll('.group-block'))
        .filter((el) => el.querySelector(':scope > .group-block-content > .group-block'));

      wrappers.forEach((wrapper) => {
        wrapper.classList.add('espresso-attitude-wrapper');

        const cards = Array.from(wrapper.querySelectorAll(':scope > .group-block-content > .group-block'));
        cards.forEach((card, index) => {
          card.classList.add('espresso-attitude-card');
          if (!card.dataset.doodleIcon) {
            card.dataset.doodleIcon = index === 0 ? 'flame' : index === 1 ? 'leaf' : 'bean';
          }

          if (!card.querySelector(':scope > .group-block-content > .espresso-attitude-card__icon')) {
            const holder = document.createElement('div');
            holder.className = 'espresso-attitude-card__icon';
            holder.setAttribute('aria-hidden', 'true');
            const content = card.querySelector(':scope > .group-block-content');
            if (content) content.prepend(holder);
          }
        });
      });
    });

    document.querySelectorAll('.espresso-attitude-card__icon').forEach((holder) => {
      if (holder.querySelector('svg')) return;
      const card = holder.closest('.espresso-attitude-card');
      const iconType = card?.dataset.doodleIcon || 'bean';

      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 64 64');
      svg.setAttribute('class', 'espresso-doodle-card-icon');
      holder.appendChild(svg);

      const rc = window.rough.svg(svg);
      const stroke = 'rgba(0, 0, 0, 0.96)';

      if (iconType === 'leaf') {
        drawPlant(rc, svg, 32, 32, 30, stroke);
      } else if (iconType === 'flame') {
        const flame = rc.path('M32 10 C38 20 28 24 36 34 C42 42 38 52 30 54 C20 53 16 43 20 35 C24 28 30 24 32 10 Z', {
          stroke,
          strokeWidth: 1.6,
          roughness: 1.5,
          fill: 'transparent'
        });
        const core = rc.path('M31 28 C34 32 31 35 33 39 C35 43 33 47 29 48 C25 47 23 43 24 39 C25 35 29 33 31 28 Z', {
          stroke,
          strokeWidth: 1.3,
          roughness: 1.5,
          fill: 'transparent'
        });
        svg.appendChild(flame);
        svg.appendChild(core);
      } else {
        drawBean(rc, svg, 32, 32, 26, stroke);
      }
    });
  }

  function run() {
    wrapHeroWord();
    applyHeroNotation();
    drawHomeBackgroundDoodles();
    drawAttitudeCardIcons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
  window.setTimeout(run, 320);
  window.setTimeout(run, 1100);
})();
